// Implementation partners — names sourced from the Annual Reports
// pillar: "employability" | "entrepreneurship" | "environment"

const BASE_PARTNERS = [
  // Employability
  { id: "anudip",        name: "Anudip Foundation",            pillar: "employability",    states: ["West Bengal", "Maharashtra", "Karnataka"],   beneficiaries: 2100, fundedCr: 3.4, since: 2019 },
  { id: "tatastrive",    name: "Tata STRIVE",                   pillar: "employability",    states: ["Maharashtra", "Gujarat", "Tamil Nadu"],      beneficiaries: 1850, fundedCr: 3.1, since: 2018 },
  { id: "edubridge",     name: "EduBridge",                     pillar: "employability",    states: ["Maharashtra", "Karnataka", "Telangana"],     beneficiaries: 1420, fundedCr: 2.6, since: 2020 },
  { id: "fuel",          name: "FUEL (Friends Union for Energising Lives)", pillar: "employability", states: ["Maharashtra", "Madhya Pradesh"], beneficiaries: 920,  fundedCr: 1.7, since: 2017 },
  { id: "centum",        name: "Centum Foundation",             pillar: "employability",    states: ["Delhi", "Haryana", "Uttar Pradesh"],         beneficiaries: 1100, fundedCr: 2.0, since: 2019 },
  { id: "yuvaunstoppable",name:"Yuva Unstoppable",              pillar: "employability",    states: ["Gujarat", "Maharashtra"],                    beneficiaries: 740,  fundedCr: 1.3, since: 2021 },
  { id: "trrain",        name: "TRRAIN",                        pillar: "employability",    states: ["Maharashtra", "Karnataka"],                  beneficiaries: 680,  fundedCr: 1.2, since: 2020 },
  { id: "vidya",         name: "VIDYA Integrated Development",  pillar: "employability",    states: ["Delhi", "Haryana"],                          beneficiaries: 540,  fundedCr: 0.9, since: 2022 },

  // Entrepreneurship
  { id: "wotr",          name: "Watershed Organisation Trust (WOTR)", pillar: "entrepreneurship", states: ["Maharashtra", "Rajasthan", "Madhya Pradesh"], beneficiaries: 4200, fundedCr: 4.8, since: 2016 },
  { id: "pradan",        name: "PRADAN",                        pillar: "entrepreneurship", states: ["Jharkhand", "Odisha", "West Bengal"],        beneficiaries: 3800, fundedCr: 4.2, since: 2017 },
  { id: "tbs",           name: "Tarun Bharat Sangh",            pillar: "entrepreneurship", states: ["Rajasthan"],                                  beneficiaries: 2600, fundedCr: 2.9, since: 2018 },
  { id: "mahashakti",    name: "Mahashakti Foundation",         pillar: "entrepreneurship", states: ["Odisha"],                                     beneficiaries: 2100, fundedCr: 2.3, since: 2019 },
  { id: "headheldhigh",  name: "Head Held High Foundation",     pillar: "entrepreneurship", states: ["Karnataka", "Tamil Nadu"],                   beneficiaries: 1800, fundedCr: 1.9, since: 2020 },
  { id: "humana",        name: "Humana People to People India", pillar: "entrepreneurship", states: ["Madhya Pradesh", "Haryana"],                 beneficiaries: 1600, fundedCr: 1.8, since: 2019 },
  { id: "siird",         name: "Society of Indian Institute for Rural Development", pillar: "entrepreneurship", states: ["Uttar Pradesh", "Bihar"], beneficiaries: 1200, fundedCr: 1.4, since: 2021 },
  { id: "ambuja",        name: "Ambuja Foundation",             pillar: "entrepreneurship", states: ["Gujarat", "Rajasthan"],                      beneficiaries: 1000, fundedCr: 1.2, since: 2021 },

  // Environment
  { id: "sankalptaru",   name: "SankalpTaru Foundation",        pillar: "environment",      states: ["Maharashtra", "Karnataka", "Uttarakhand", "Tamil Nadu"], beneficiaries: 0, fundedCr: 5.2, since: 2018, trees: 280000 },
  { id: "fmc",           name: "Foundation for MSME Clusters",  pillar: "environment",      states: ["Maharashtra", "Gujarat", "Tamil Nadu"],      beneficiaries: 520,  fundedCr: 2.4, since: 2019, msmes: 520 },
  { id: "raah",          name: "Raah Foundation",               pillar: "environment",      states: ["Maharashtra"],                                beneficiaries: 0,    fundedCr: 1.8, since: 2020, trees: 95000 },
  { id: "grow",          name: "Grow Trees",                    pillar: "environment",      states: ["Karnataka", "Andhra Pradesh"],                beneficiaries: 0,    fundedCr: 1.4, since: 2021, trees: 75000 },
];

// Deterministic 32-bit hash so values are stable across renders / FY switches
function hash(str) {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0);
}

function pick(seed, arr) {
  return arr[seed % arr.length];
}

function enrich(p) {
  const h1 = hash(p.id + ":score");
  const h2 = hash(p.id + ":kpi");
  const h3 = hash(p.id + ":compliance");
  const h4 = hash(p.id + ":count");
  const h5 = hash(p.id + ":grants");
  const h6 = hash(p.id + ":util");

  // Avg project score: 3.2 .. 4.9
  const avgScore = +(3.2 + ((h1 % 170) / 100)).toFixed(2);

  // KPI completion: 45 .. 100
  const kpiCompletion = 45 + (h2 % 56);

  // # of grants per partner: 3 .. 9 (deterministic)
  const grantCount = 3 + (h5 % 7);

  // Utilisation (% of disbursed actually spent): 58 .. 97
  const utilisationPct = 58 + (h6 % 40);
  const utilisedCr = +(p.fundedCr * (utilisationPct / 100)).toFixed(2);

  // Compliance: weighted — most partners "all submitted", some report-overdue, fewer UC-overdue
  const types = ["all_submitted", "all_submitted", "all_submitted", "reports_overdue", "reports_overdue", "uc_overdue"];
  const complianceType = pick(h3, types);
  const overdueCount = complianceType === "all_submitted"
    ? 0
    : 1 + (h4 % Math.max(1, Math.min(3, grantCount - 1))); // 1..min(3, grantCount-1)

  return {
    ...p,
    avgScore,
    kpiCompletion,
    grantCount,
    utilisationPct,
    utilisedCr,
    compliance: { type: complianceType, count: overdueCount },
  };
}

export const PARTNERS = BASE_PARTNERS.map(enrich);

export const partnersByPillar = (pillarId) =>
  PARTNERS.filter((p) => p.pillar === pillarId);

// ─── Helpers used by the Partner cards ─────────────────────────────────────
export const scoreRAG = (score) => {
  if (score >= 4.0) return { tone: "green", label: "Strong",   dot: "#16A34A" };
  if (score >= 3.4) return { tone: "amber", label: "On watch", dot: "#D97706" };
  return                    { tone: "red",   label: "At risk", dot: "#DC2626" };
};

export const kpiRAG = (pct) => {
  if (pct >= 80) return { tone: "green", label: "On track", dot: "#16A34A" };
  if (pct >= 50) return { tone: "amber", label: "At risk",  dot: "#D97706" };
  return                { tone: "red",   label: "Behind",   dot: "#DC2626" };
};

export const COMPLIANCE_META = {
  all_submitted:   { label: "All reports submitted", tone: "green" },
  reports_overdue: { label: "Report overdue",        tone: "amber" },
  uc_overdue:      { label: "UC overdue",            tone: "red"   },
};

export const TONE_CHIP = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50  text-amber-700  border-amber-200",
  red:   "bg-rose-50   text-rose-700   border-rose-200",
};
